import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Col, Card, Container, Row, CardBody, Button,
} from 'reactstrap';
import { Form, Input } from 'antd';
import { Link } from 'react-router-dom';
import { formItemLayout } from '../../Bike_model_create/components/statics';
import { createBikeModelVariantRequest } from '../redux/actions/create_bike_model_variant.actions';
import { history } from '../../../../config/history';
import { NotFound } from '../../../App/components/NotFound';
import { checkPermissionsHOC } from '../../../App/CheckPermissions';

const mapStateToProps = (state) => {
    const { variants } = state.PlatformManagement.Bike_management;
    return { variants, views_permissions: state.App.Permissions.views_permissions };
}; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(checkPermissionsHOC(class BikeAddVariant extends PureComponent {
    constructor(props) {
    // const { model, brand, cc, variation } = props.location.state;
        super(props);
        this.state = {
            year: null,
            stock_limit: null,
            current_stock_count: 0,
            name: '',
            // name: `${brand} ${model}${variation} ${cc}cc`,
            margin_by_quarter: {
                q1: null,
                q2: null,
                q3: null,
                q4: null,
            },
            guide_price: {
                min_price: null,
                max_price: null,
            },
            ref_bike_model: '',
            // ref_bike_model: this.props.location.state.model_id
        };
    }


  goBack = () => history.goBack();

  handleChange = (name, value) => this.setState({ [name]: value });

  handleChangeNested = (name, value, prop) => this.setState(prevState => ({ ...prevState, [prop]: { ...prevState[prop], [name]: value } }));

  handleSubmit = (event) => {
      event.preventDefault();
      this.props.dispatch(createBikeModelVariantRequest(this.state, this.props.location.state.model_id));
  };

  componentWillUnmount() {
      this.props.dispatch({ type: 'RESET_PERMISSIONS' });
  }

  render() {
      // const { model, brand } = this.props.location.state;
      const { views_permissions } = this.props;
      const variant_create_access = views_permissions['view://PlatformManagement/Bike_variant_create'];
      if (!variant_create_access) {
          return <NotFound />;
      }
      return (
          <Container className="dashboard">
              <div className="profile">
                  <Col md={12}>
                      <nav aria-label="breadcrumb">
                          <ol className="breadcrumb customBreadcrumb">
                              <li className="breadcrumb-item">
                                  <Link to="/PlatformManagement/BikeManagement">Bike Management</Link>
                              </li>
                              {/* <li className="breadcrumb-item" style={{color: '#70bbfd', cursor: 'pointer'}} */}
                              {/* onClick={this.goBack}>{brand} {model}</li> */}
                              <li className="breadcrumb-item active" aria-current="page">Variant</li>
                          </ol>
                      </nav>
                  </Col>
                  <Col md={6}>
                      <h3 className="page-title">Add New Variant</h3>
                  </Col>
                  <Card>
                      <CardBody>
                          <Form style={{ paddingTop: '10px' }}>
                              <Row style={{ paddingBottom: '15px' }}>
                                  <Col span={12}>
                                      <FormItem label="Margin Q1" {...formItemLayout} className="variant_field">
                                          <Input
                                              onChange={event => this.handleChangeNested('q1', +event.target.value, 'margin_by_quarter')}
                                              placeholder="Margin Q1"
                                          />
                                      </FormItem>
                                  </Col>
                                  <Col span={12}>
                                      <FormItem label="Stock Limit" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChange('stock_limit', +event.target.value)}
                                              placeholder="Stock Limit"
                                          />
                                      </FormItem>
                                  </Col>
                              </Row>
                              <Row style={{ paddingBottom: '15px' }}>
                                  <Col span={12}>
                                      <FormItem label="Margin Q2" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChangeNested('q2', +event.target.value, 'margin_by_quarter')}
                                              placeholder="Margin Q2"
                                          />
                                      </FormItem>
                                  </Col>
                                  <Col span={12}>
                                      <FormItem label="Min Price" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChangeNested('min_price', +event.target.value, 'guide_price')}
                                              placeholder="Min Price"
                                          />
                                      </FormItem>
                                  </Col>
                              </Row>
                              <Row style={{ paddingBottom: '15px' }}>
                                  <Col span={12}>
                                      <FormItem label="Margin Q3" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChangeNested('q3', +event.target.value, 'margin_by_quarter')}
                                              placeholder="Margin Q3"
                                          />
                                      </FormItem>
                                  </Col>
                                  <Col span={12}>
                                      <FormItem label="Max Price" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChangeNested('max_price', +event.target.value, 'guide_price')}
                                              placeholder="Max Price"
                                          />
                                      </FormItem>
                                  </Col>
                              </Row>
                              <Row style={{ paddingBottom: '15px' }}>
                                  <Col span={12}>
                                      <FormItem label="Margin Q4" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChangeNested('q4', +event.target.value, 'margin_by_quarter')}
                                              placeholder="Margin Q4"
                                          />
                                      </FormItem>
                                  </Col>
                                  <Col span={12}>
                                      <FormItem label="Year" {...formItemLayout}>
                                          <Input
                                              onChange={event => this.handleChange('year', +event.target.value)}
                                              placeholder="Year"
                                          />
                                      </FormItem>
                                  </Col>
                              </Row>
                              <Row style={{ paddingBottom: '15px' }}>
                                  <Col span={12}>
                                      <FormItem label="Name" {...formItemLayout}>
                                          <Input
                                              value={this.state.name}
                                              disabled
                                              onChange={event => this.handleChange('name', event.target.value)}
                                              placeholder="Variant Name"
                                          />
                                      </FormItem>
                                  </Col>
                                  <Col span={12} />
                              </Row>
                              <Col span={12} />
                              <Col span={12}>
                                  <Button
                                      color="primary"
                                      style={{ float: 'right', marginLeft: 15 }}
                                      onClick={this.handleSubmit}
                                  >
                                      Add
                                  </Button>
                                  <Button style={{ float: 'right' }} onClick={this.goBack}>Back</Button>
                              </Col>
                          </Form>
                      </CardBody>
                  </Card>
              </div>
          </Container>
      );
  }
}, ['view://PlatformManagement/Bike_variant_create']));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_variant_create/components/BikeAddVariant.js